import React from 'react'
import bandPhoto from '../images/NP/Gemini_Generated_Image_6w7y2g6w7y2g6w7y.png'
import { Helmet } from 'react-helmet-async'

const Bio = () => {
  return (
    <div>
      <Helmet>
        <title>The Non-Prophets - Bio</title>
        <meta name="description" content="Learn more about The Non-Prophets." />
        <link rel="canonical" href="/bio" />
      </Helmet>
      <header className="h-screen/3 overflow-hidden pt-20 md:pt-0 ">
        <div className="relative">
          <img
            src={bandPhoto}
            alt="The Non-Prophets Boys photo"
            className="w-full h-[35vh] md:h-[50vh] object-cover object-[50%_30%] opacity-50"
          />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <h1 className="text-gray-800 text-2xl md:text-3xl tracking-widest">
              Bio
            </h1>
          </div>
        </div>
      </header>
      <main className="flex bg-slate-50">
        <div className="items-center  mx-auto ">
          <p className=" max-w-4xl p-8">
            The Non-Prophets are Don Story, Billy Gee, Mel Jones & Randy
            Gambill, four veteran musicians based in the foothills of North
            Carolina's Blue Ridge Mountains. Our repertoire is a dazzling
            Americana mix of covers and our own original material. Individually
            throughout our careers, we have shared the stage and/or studio with
            Bo Diddley, Doc Watson, Jim Lauderdale, Charlie Waller, Joe South,
            The Guess Who, Steppenwolf, Wet Willie, The Temptations, John Cowan,
            The James Gang, Alison Krauss, Tim O’Brien, Mark O’Connor and Darren
            & Brooke Aldrige, to name a few. With backgrounds in rock, soul,
            bluegrass, country, and R&B our motto is, “We have all travelled
            long, wayward roads to arrive at the same place.” <br></br>
            <br></br>Members of The Non-Prophets have played at a long list of
            festivals and venues including The Grand Ole Opry, Walnut Valley
            Festival (Winfield, Kansas) and at every Merlefest since its
            inception. Member's songs have been featured on BBC (British
            Broadcasting Company) Radio, NPR Radio affiliates and PBS-TV Song of
            the Mountains.
          </p>
          <div className="flex justify-center items-center mx-auto"></div>
        </div>
      </main>
    </div>
  )
}

export default Bio
